import { cardPreviewActions } from "./card-preview-slice";
import config from "./config";
import { getCsrfToken } from './config';

export const fetchOccasionData = (occasionId) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch(
        config.settings.apiEndpoint +
          "api/requests/GetMassRequestOccasion/" +
          occasionId,
        {
          method: "GET",
          credentials: "include",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          },
        }
      );

      if (!response.ok) {
        throw new Error("Could not fetch occasion data!");
      }

      const data = await response.json();

      return data;
    };

    try {
      const occasionData = await fetchData();

      if (!config.settings.cartItemId && config.settings.massType === "individual") {
        const pageContainer = document.querySelector(".page");
        const pageHeading = document.querySelector(".page > h1:first-child");
        if (pageHeading) {
          pageHeading.textContent = occasionData.ConfiguratorHeading;
        } else {
          if (pageContainer) {
            const heading1 = document.createElement("h1");
            const node = document.createTextNode(
              occasionData.ConfiguratorHeading
            );
            heading1.appendChild(node);
            document.querySelector(".page").prepend(heading1);
          }
        }
      }

      dispatch(cardPreviewActions.setSelectedOccasionState({selectedOccasion: occasionData, massType: config.settings.massType}));
    } catch (error) {
      console.log(error);
    }
  };
};
